import pkdApi from 'store/api/pkd';

const entityApi = pkdApi.injectEndpoints({
  endpoints : (build) => ({
    getEntityList : build.query({
      query : ({ entityName, entityParams }) => {
        return {
          url    : '/entity/list',
          method : 'POST',
          body   : {
            entityName,
            params : {
              ...entityParams,
              studyVersionId : 1,
            },
          },
        };
      },
      transformResponse : ({ data }, _, args) =>
        args?.entityParams?.personType
          ? data?.find?.(({ name }) => name === args?.entityParams?.personType)
          : data,
    }),
    refetchEntityList : build.mutation({
      query : ({ entityName, entityParams }) => {
        return {
          url    : '/entity/list',
          method : 'POST',
          body   : {
            entityName,
            params : {
              ...entityParams,
              studyVersionId : 1,
            },
          },
        };
      },
      transformResponse : ({ data }, _, args) =>
        args?.entityParams?.personType
          ? data?.find?.(({ name }) => name === args?.entityParams?.personType)
          : data,
    }),
    getConsents : build.query({
      query : ({ entityName, entityParams }) => {
        return {
          url    : '/entity/list',
          method : 'POST',
          body   : {
            entityName,
            params : {
              ...entityParams,
              studyVersionId : 1,
            },
          },
        };
      },
      transformResponse : ({ data }) => data?.consents,
    }),
  }),
  overrideExisting : false,
});

export const {
  useGetEntityListQuery,
  useGetConsentsQuery,
  useRefetchEntityListMutation,
} = entityApi;
